<section class="flex flex-col text-black">
  <!-- Page Content Wrapper with Max Width -->
  <main class="w-full max-w-[1200px] mx-auto flex-1">
    <!-- Hero Section -->
    <section
      class="w-full h-64 md:h-[25rem] bg-black flex justify-center items-center overflow-hidden mb-10"
    >
      <img
        src="assets/images/landing-page-image.jpg"
        class="h-full object-contain"
        alt="Landing page"
      />
    </section>

    <!-- CTA -->
    <div class="text-center mb-12">
      <h2 class="text-xl md:text-xl text-gray-700 mb-4">
        Discover practical tech skills designed for your lifestyle.
      </h2>
      <div class="relative inline-block">
        <button
          mat-flat-button
          color="primary"
          [matMenuTriggerFor]="enrollPopover"
          class="w-48 text-white font-semibold py-2 px-6"
        >
          Enroll
        </button>

        <mat-menu #enrollPopover="matMenu" class="w-72 p-4">
          <div class="text-sm text-gray-800">
            Enrollment is limited to invited participants at this time.<br />
            For access, please contact us at <strong>(240) 877-8161</strong>.
          </div>
        </mat-menu>
      </div>
    </div>

    <!-- Course Grid -->
    <section
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      <ng-container *ngFor="let course of courses">
        <div
          class="flex flex-col justify-between border rounded-lg overflow-hidden transition-shadow hover:shadow-lg cursor-pointer"
          [ngClass]="{
            'bg-green-50': isEnrolled(course.id),
            'bg-gray-50': course.price === 0
          }"
          (click)="enroll(course)"
        >
          <img [src]="course.image" class="w-full h-40 object-cover" />
          <div class="p-4 flex flex-col gap-2">
            <h3
              class="text-blue-800 text-lg font-semibold text-center truncate"
              [title]="course.title"
            >
              {{ course.title }}
            </h3>
            <p
              class="text-gray-700 text-sm line-clamp-3"
              [title]="course.description"
            >
              {{ course.description }}
            </p>
          </div>
          <div class="px-4 pb-4">
            <button
              class="w-full text-white font-medium py-2 rounded transition duration-300"
              [ngClass]="{
                'bg-green-800 hover:bg-green-600': isEnrolled(course.id),
                'bg-blue-800 hover:bg-blue-600': !isEnrolled(course.id)
              }"
              [title]="
                isEnrolled(course.id)
                  ? 'Go to ' + course.title
                  : 'Enroll to ' + course.title
              "
            >
              {{ isEnrolled(course.id) ? "Go" : "Enroll" }} to
              {{ course.title }}
              <span *ngIf="!isEnrolled(course.id)">
                [{{ course.price === 0 ? "Free" : "$" + course.price }}]
              </span>
            </button>
          </div>
        </div>
      </ng-container>
    </section>
  </main>
</section>
